import { axiosFactory, errorHandler, currentPage } from '@/configs/axios'

export const getApprovals = {
  api: (page) => {
    return axiosFactory()
      .auth.get(`approvals${page ? `/${currentPage(page)}` : '/'}`)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        errorHandler(error)
      })
  },
}

export const updateApproval = {
  api: (id, approved) => {
    return axiosFactory()
      .auth.put(`approvals/${id}/`, { approved })
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        errorHandler(error)
      })
  },
}
